export enum EMyGemsItemType {
  LINK = 'Link',
}

export enum EMyGemsFormKeys {
  NAME = 'itemName',
  SEQUENCE = 'itemSeq',
  IS_NEW = 'isNew',
  ACTIVE = 'itemActive',
  URL = 'itemUrl',
}

export interface IMyGemsFormState {
  [EMyGemsFormKeys.NAME]: string | null;
  [EMyGemsFormKeys.SEQUENCE]: number | null;
  [EMyGemsFormKeys.IS_NEW]: boolean;
  [EMyGemsFormKeys.ACTIVE]: boolean;
  [EMyGemsFormKeys.URL]: string | null;
}
